import { AppThunk } from "../../../../store";
import { formatChecklistForDocxGeneration } from "../checklistUtils";
import { openapi } from "../../../../../openapi";
import { ChecklistTemplateName } from "@schemas/checklistSchema";
import saveAs from "file-saver";
import { setShowFailedMessageThunk } from "../../../../global/globalSlice";

export const base64TilBlob = (base64: string, mime: string): Blob => {
  const bin = atob(base64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: mime });
};

export const thunkGenerateChecklistReportDocxAndDownload =
  (): AppThunk<Promise<void>> => async (dispatch, getState) => {
    const project = getState().adminReducer.project;
    const checklist = getState().checklistReducer.checklist;
    const checklistCategories = getState().checklistReducer.checklistCategories;
    const checklistItems = getState().checklistReducer.checklistItems;
    const signedBy = getState().globalReducer.user;
    if (!project || !checklist || !checklistCategories || !checklistItems || !signedBy) {
      const missing: string[] = [];
      if (!project) missing.push("project");
      if (!checklist) missing.push("checklist");
      if (!checklistCategories || checklistCategories.length === 0) missing.push("checklistCategories");
      if (!checklistItems || checklistItems.length === 0) missing.push("checklistItems");
      if (!signedBy) missing.push("signedBy");
      if (missing.length) {
        console.error("Manglende data for å generere sjekkliste-DOCX. Mangler:", missing.join(", "));
        return;
      }
    }

    // 1) Bygg datagrunnlag til dokumentgeneratoren (samme som før)
    const data = formatChecklistForDocxGeneration({
      project,
      checklist,
      checklistCategories,
      checklistItems,
      signedBy,
    });

    console.log(data);

    // 2) Velg mal basert på antall aktive kolonner
    const typer = [checklist.checkTypes.check1, checklist.checkTypes.check2, checklist.checkTypes.check3].filter(
      (v) => v.active === true,
    );
    const antallKolonner = typer.length;
    const templateName = `checklist_${antallKolonner}col.docx`;

    // 3) Kjør RTK Query-mutasjonen (tRPC: /rapport/generate-docx) via dispatch().unwrap()
    const outputName = `${project.maconomy.name} - ${checklist.name}`;

    try {
      const result = await dispatch(
        openapi.endpoints.postChecklistGenerateDocxAzure.initiate({
          body: {
            data: data as any,
            templateName: templateName as ChecklistTemplateName,
            outputName, // sendes for å få fint filnavn tilbake,
          },
        }),
      ).unwrap();

      // 4) Base64 -> Blob og last ned
      const blob = base64TilBlob(result.base64, result.mime);
      const filnavn = outputName ? `${outputName}.docx` : result.filename;
      saveAs(blob, filnavn);
    } catch (err) {
      dispatch(
        setShowFailedMessageThunk(
          "Noe gikk galt ved generering av sjekkliste-DOCX. Prøv igjen, eller kontakt support hvis problemet vedvarer.",
        ),
      );
    }
  };
